import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgesService } from './logic/badges.service';
import { BadgesDaoService } from './dao/badges-dao.service';
import { BadgesStorageDaoService } from './dao/branches-dao/badges-storage-dao.service';
import { BadgesLogicService } from './logic/badges/badges-logic.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: BadgesService, useClass: BadgesLogicService },
    { provide: BadgesDaoService, useClass: BadgesStorageDaoService }
  ]
})
export class BadgesModule {}
